<!--
 * @Author: your name
 * @Date: 2020-10-22 17:59:16
 * @LastEditTime: 2020-10-25 11:11:23
 * @LastEditors: Please set LastEditors
 * @Description: 查看详细简历
 * @FilePath: /zhulogic-design-cloud-next/src/views/workLocation/workListsDetail.vue
-->
<template>
  <div class="worker-details-view">
    <div class="work-detail pageWidtn">
      <div
        v-if="pageLoading"
        class="loading"
        style="margin-top:200px;margin-bottom:200px"
      >
        <div class="align-center">
          <img style="width:100px;" src="@/assets/new-global.gif" alt="" />
        </div>
      </div>
      <Row :gutter="40" v-if="!pageLoading && detail">
        <Col span="17" class="left">
          <Row
            style="width:100%;"
            type="flex"
            justify="center"
            align="bottom"
            :gutter="0"
          >
            <Col span="3" style="width:80px;font-size:0px">
              <img
                v-if="!detail.avatarFile"
                class="factory-img"
                src="https://oss.zhulogic.com/planImage/fa/877_dir/5WKBaPrpdAWtkHiEjjS4HjyGrKzdXPfh75.png"
                alt=""
              />
              <img
                v-else
                class="factory-img"
                :src="ossPrefix + detail.avatarFile.key"
                alt=""
              />
            </Col>
            <Col span="21" class="name-view">
              <Row class="name">
                <Col
                  span="10"
                  style="font-size: 20px;font-weight: bold;color: #373737;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                  >{{ detail.name }}</Col
                >
                <Col
                  v-if="
                    detail.expectPositionList &&
                      detail.expectPositionList.length > 0
                  "
                  span="14"
                  style="text-align:right;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                >
                  <span
                    style="font-size: 20px;font-weight: bold; color: #E56A69"
                    v-for="(item, index) in detail.expectPositionList"
                    :key="index"
                    >{{ item }}
                    <span
                      style="font-size: 20px;font-weight: bold; color: #E56A69"
                      v-if="index + 1 !== detail.expectPositionList.length"
                    >
                      /
                    </span></span
                  >
                </Col>
              </Row>
            </Col>
          </Row>

          <div class="name-title">
            <span class="name-title-tag"></span>
            <span class="name-title-name">职位内容</span>
          </div>

          <div class="name-contont">
            <p>性别：{{ detail.sex == 1 ? '男' : '女' }}</p>
            <p>年龄：{{ detail.age }}</p>
            <p>学历：{{ detail.educationDisplay }}</p>
            <p>工作经验：{{ detail.experienceDisplay }}</p>
            <p>期望工作地点： {{ getAddress(detail.locationId) }}</p>
            <p>手机号：{{ detail.phone }}</p>
            <p>邮箱：{{ detail.email }}</p>
          </div>

          <div class="name-title">
            <span class="name-title-tag"></span>
            <span class="name-title-name">个人介绍</span>
          </div>

          <div class="name-contont">
            <p>
              {{ detail.description }}
            </p>
          </div>

          <div class="name-title">
            <span class="name-title-tag"></span>
            <span class="name-title-name">作品</span>
          </div>

          <div class="name-contont" style="margin-bottom:20px">
            <div v-if="detail.workFileList && detail.workFileList.length > 0">
              <p
                v-for="(item, index) in detail.workFileList"
                style="margin-bottom:5px"
              >
                <a style="color:#576B95" :href="ossPrefix + item.key">{{
                  item.name
                }}</a>
              </p>
            </div>
            <p v-else>
              暂未公开
            </p>
          </div>

          <div class="name-contont">
            <div v-if="detail.favoriteList && detail.favoriteList.length > 0">
              <div
                class="favoriteList-view"
                :key="index"
                v-for="(item, index) in detail.favoriteList"
                @click="openFavoriteItem(item)"
              >
                <Row>
                  <Col
                    span="24"
                    style="font-size: 14px; font-weight: 500;color: #373737;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 9px;"
                    class="favoriteList-view-title"
                    >{{ item.name }}</Col
                  >
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span="7" v-if="smallDesinger && smallDesinger.length > 0">
          <div class="small">
            相似设计师
          </div>
          <Row :gutter="0">
            <Col
              span="24"
              style="margin-bottom:26px"
              :key="index"
              v-for="(item, index) in smallDesinger"
            >
              <item-view :items="item"></item-view>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>

    <!-- 查看收藏夹详情 -->
    <collection-dialog ref="collectionDialog"></collection-dialog>
  </div>
</template>

<script>
import itemView from './components/item-worker'
import axios from 'axios'
import collectionDialog from '../personal/common/work-collection-item-dialog'
import { getAddress } from '@/utils'
export default {
  name: '',
  data() {
    return {
      getAddress: getAddress,
      pageLoading: false,
      detail: null,
      smallDesinger: [],
      checkLoading: false,
    }
  },
  components: {
    itemView,
    collectionDialog,
  },
  methods: {
    getDetail() {
      this.pageLoading = true
      axios
        .get(`designer_api/job_resume/${this.$route.query.id}/detail`)
        .then((res) => {
          this.detail = res
          this.pageLoading = false
        })
        .catch((err) => {
          this.pageLoading = false
        })
    },
    // 相似设计师
    getSmallDesinger() {
      axios
        .get(`/designer_api/job_resume/${this.$route.query.id}/similarity`)
        .then((res) => {
          this.smallDesinger = res || []
        })
    },
    // 打开收藏夹详情列表
    openFavoriteItem(item) {
      this.$refs.collectionDialog.open(item)
    },
  },
  created() {
    this.getDetail()
    this.getSmallDesinger()
  },
}
</script>

<style lang="scss" scoped>
.worker-details-view {
  background: #f3f5f9;
  padding-top: 30px;
  .work-detail {
    min-height: 600px;
    .factory-img {
      width: 80px;
      height: 80px;
      background: #f3f5f9;
      border: 1px solid #efefef;
      object-fit: cover;
    }
  }
  .name-view {
    height: 60px;
    background: #fffbfa;
    padding: 20px;
    padding-top: 15px;
  }

  .name-title {
    margin-top: 50px;
    margin-bottom: 30px;
    margin-left: 10px;
    .name-title-tag {
      display: inline-block;
      width: 3px;
      background: #e56a69;
      margin-right: 8px;
      vertical-align: middle;
      height: 14px;
      margin-top: -5px;
    }
    .name-title-name {
      font-size: 16px;
      font-weight: bold;
      color: #373737;
    }
  }
  .name-contont {
    margin-bottom: 50px;
    margin-left: 10px;
    > p {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-top: 10px;
    }
  }
  .small {
    height: 44px;
    background: #f9fafc;
    line-height: 44px;
    padding: 0 15px;
    border-left: 3px solid #000;
    margin-bottom: 30px;
    font-size: 16px;
    font-weight: bold;
    color: #373737;
  }
  .favoriteList-view {
    width: 400px;
    height: 40px;
    background: #f9fafc;
    padding: 0 20px;
    margin-top: 10px;
    cursor: pointer;
  }
}
</style>
